import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "helpers/sf_constants";
import BillingInformation from "pages/Authentication/BillingInformation";
import React, { useEffect } from "react"
import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  Container,
} from "reactstrap"

const RegisterCheck = () => {
  const {
    current_user, user
  } = useSelector((state) => ({
    current_user: state.Login.current_user,
    user: state.Account.user

  }), shallowEqual);
  const [stripe_options, setStripeOptions] = useState({});
  useEffect(() => {
    if (user) {
      const billing_setting = JSON.parse(user).data.billing_setting
      // Retrieve Client Secret
      const clientSecret = billing_setting.pending_client_secret;

      setStripeOptions({ clientSecret, appearance: {} });
    }
  }, [user]);
  return (
    <>
      <React.Fragment>
        <div className="page-content" id="page-content-wrapper">
            <Container fluid>
            {JSON.parse(user)?.data?.billing_setting?.pending_client_secret ? <Elements stripe={stripePromise} options={stripe_options}>
                <BillingInformation
                clientSecret={JSON.parse(user)?.data?.billing_setting?.pending_client_secret}/>
              </Elements>: <div>Please refresh...</div>
          }
            </Container>
        </div>
      </React.Fragment>
    </>
  )
}

export default RegisterCheck
